import React from "react";
import { P_Props } from "./AgentForm.type";
import { Form, Field } from "react-final-form";
import { FormUtil, FormUIUtil, loadCallback } from "../../../utils";
import { Loading, SimpleModalHeader } from "../../components";
import { Grid, TextField, Select, FormControl, FormControlLabel, Switch } from "@material-ui/core";
import { FORM_MODE, AgentOutputModel, CityDataModel } from "../../../models";
import { REGEX, COUNTRY } from "../../../constants";

const AgentFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;

  const bindingAgentDataToForm = (data: AgentOutputModel) => {
    return {
      code: data.code,
      companyPhone: data.companyPhone,
      companyName: data.companyName,
      website: data.website || undefined,
      companyEmail: data.companyEmail || undefined,
      country: data.country,
      city: data.city,
      street: data.street,
      contactName: data.contactName,
      contactEmail: data.contactEmail,
      contactPhone: data.contactPhone,
      jobTitle: data.jobTitle || undefined,
      description: data.description || undefined,
      status: data.status
    };
  };

  return (
    <>
      <div className="agent-form">
        <SimpleModalHeader
          title={props.mode === FORM_MODE.CREATE ? "New Partner" : "Edit Partner"}
          onClose={() => {
            props.onCancel();
          }}
        />
        <div className="agent-form__container">
          <div className="agent-form__box">
            {props.loading && <Loading />}
            {!props.loading && (
              <Form
                initialValues={
                  props.initData
                    ? bindingAgentDataToForm(props.initData)
                    : {
                      status: true
                    }
                }
                initialValuesEqual={() => true}
                onSubmit={async (values, form) => {
                  props.onSubmit(values);
                }}
                render={({ handleSubmit, form, pristine }) => {
                  submit = handleSubmit;

                  return (
                    <form onSubmit={handleSubmit}>
                      <Grid container spacing={2}>

                        {/* COMPANY INFORMATION */}
                        <Grid item xs={12}>
                          <h4 className="agent-form__section">COMPANY INFORMATION</h4>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field name="code">
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "ID",
                                <TextField
                                  {...input}
                                  {...rest}
                                  disabled
                                  fullWidth
                                  placeholder=""
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="filled"
                                  onChange={(e) => input.onChange(e.target.value)}
                                />, false, true
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field name="companyName" validate={FormUtil.Rule.required("This is required field")}>
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Company name",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder="Text input"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />, false, true
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field
                            name="companyPhone"
                            validate={FormUtil.composeValidators([
                              FormUtil.Rule.required("This is required field"),
                              FormUtil.Rule.pattern(REGEX.PHONE_NUMBER, { errorMessage: "Invalid phone number" }),
                            ])}
                          >
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Phone Number",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder={`Vd. 1900 066 692`}
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />, false, true
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field
                            name="companyEmail"
                            validate={FormUtil.composeValidators([
                              // FormUtil.Rule.required("Xin nhập email"),
                              FormUtil.Rule.pattern(REGEX.EMAIL, { errorMessage: "Invalid email" }),
                            ])}
                          >
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Email",
                                <TextField
                                  {...input}
                                  {...rest}
                                  // disabled={props.mode === FORM_MODE.EDIT && Boolean(props.initData?.companyEmail)}
                                  fullWidth
                                  placeholder="Vd. ten@domain.com"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field name="website">
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Website",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder="Text input"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field name="country" validate={FormUtil.Rule.required("This is required field")}>
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Country",
                                <FormControl
                                  style={{ width: "100%" }}
                                  variant="outlined"
                                  className="agent-form__select"
                                >
                                  <Select
                                    {...input}
                                    {...rest}
                                    native
                                    value={input.value}
                                    onChange={(e) => {
                                      input.onChange(e.target.value);
                                      form.change("city", undefined);
                                    }}
                                    error={meta.error && meta.touched}
                                  >
                                    <option value="">Select...</option>
                                    {COUNTRY.map((country, index) => (
                                      <option key={index} value={country.countryName}>{country.countryName}</option>
                                    ))}
                                  </Select>
                                </FormControl>, false, true
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field name="city" validate={FormUtil.Rule.required("This is required field")}>
                            {({ input, meta, ...rest }) => {
                              const selectedCountry = form.getFieldState("country")?.value;
                              const city: CityDataModel[] = COUNTRY.find((country) => country.countryName === selectedCountry)?.regions || [];

                              return FormUIUtil.renderFormItem(
                                "City",
                                <FormControl
                                  style={{ width: "100%" }}
                                  variant="outlined"
                                  className="agent-form__select"
                                >
                                  <Select
                                    {...input}
                                    {...rest}
                                    native
                                    value={input.value}
                                    onChange={(e) => {
                                      input.onChange(e.target.value);
                                    }}
                                    error={meta.error && meta.touched}
                                  >
                                    <option value="">Select...</option>
                                    {city.map((city, index) => (
                                      <option key={index} value={city.name}>{city.name}</option>
                                    ))}</Select>
                                </FormControl>, false, true
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field name="street" validate={FormUtil.Rule.required("This is required field")}>
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Street",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder="Text input"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />, false, true
                              );
                            }}
                          </Field>
                        </Grid>

                        {/* PRIMARY CONTACT */}
                        <Grid item xs={12}>
                          <h4 className="agent-form__section">PRIMARY CONTACT</h4>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <Field name="contactName" validate={FormUtil.Rule.required("This is required field")}>
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Full name",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder="Text input"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />, false, true
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field
                            name="contactEmail"
                            validate={FormUtil.composeValidators([
                              FormUtil.Rule.required("This is required field"),
                              FormUtil.Rule.pattern(REGEX.EMAIL, { errorMessage: "Invalid email" }),
                            ])}
                          >
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Email",
                                <TextField
                                  {...input}
                                  {...rest}
                                  // disabled={props.mode === FORM_MODE.EDIT && Boolean(props.initData?.contactEmail)}
                                  fullWidth
                                  placeholder="Vd. ten@domain.com"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />, false, true
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field
                            name="contactPhone"
                            validate={FormUtil.composeValidators([
                              FormUtil.Rule.required("This is required field"),
                              FormUtil.Rule.pattern(REGEX.PHONE_NUMBER, { errorMessage: "Invalid phone number" }),
                            ])}
                          >
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Phone Number",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder={`Vd. 1900 066 692`}
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />, false, true
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field name="jobTitle">
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Job title",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder="Text input"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                />
                              );
                            }}
                          </Field>
                        </Grid>

                        {/* DESCRIPTION */}
                        <Grid item xs={12}>
                          <h4 className="agent-form__section">DESCRIPTION</h4>
                        </Grid>
                        <Grid item xs={12}>
                          <Field name="description">
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Is there anything else that you would like us to know?",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  multiline
                                  placeholder="Text input"
                                  className="form-textarea-field"
                                  id="outlined-textarea"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                />
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12}>
                          <Field name="status">
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Status",
                                <FormControlLabel
                                  control={
                                    <Switch
                                      {...input}
                                      {...rest}
                                      checked={input.value}
                                      // checked={props.AgentStatus.status}
                                      onChange={(e) => {
                                        // props.onChangeAgentStatus(e.target.checked);
                                        input.onChange(e.target.checked);
                                      }}
                                      className="app-switch-box"
                                    />
                                  }
                                  label={
                                    <div className="form-label" style={{ marginBottom: 0 }}>
                                      {props.agentStatus.status ? "Active" : "In active"}
                                    </div>
                                  }
                                />
                              );
                            }}
                          </Field>
                        </Grid>
                      </Grid>
                    </form>
                  );
                }}
              />
            )}
          </div>
        </div>
        <div className="agent-form__footer">
          <button
            className="btn cancel"
            onClick={(e) => {
              e.preventDefault();
              props.onCancel();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn save"
            onClick={(e) => {
              loadCallback(submit, e);
            }}
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
};

export default AgentFormPresenter;
